import React from "react";
import Helmet from "react-helmet";
import { Nav, NavItem, NavLink } from "reactstrap";
import { Link } from "@reach/router";

import Navigation from "../../../components/WaveNavigation";

export default () => (
  <div>
    <Helmet
      title="Fire Island Ferries | Freight Info"
      meta={[
        {
          name: "description",
          content: "Fire Island Ferries Contact Information",
        },
        {
          name: "keywords",
          content: "Fire Island, New York, Long Island, Ferries, Water Taxi",
        },
      ]}
    />
    <Navigation />
    <div className="container page">
      <div className="row">
        <div className="col-xl">
          <div className="heading">
            <h2>Freight Info</h2>
            <h1>Freight Shipping Services</h1>
          </div>
          <p>
            This page is intended to provide some helpful guidelines and
            information pertaining to Fire Island Ferries, Inc. freight boat
            service. Through our experience, we have found it necessary to
            formulate these policies.
          </p>
          <p>
            We strive to provide consistent and superior service given the
            constraints of time, the variations in weather, the unforgiving
            marine environment and the finite limits of shipping/warehouse
            space. So, while some of these policies may seem arbitrary, they
            have evolved through time for the overall benefit of our customers,
            the vendors, and the Fire Island Ferries.
          </p>
          <p>
            We would like to make your freight shipping experience as painless
            and expeditious as possible. Your cooperation will help immensely.
            If you have any questions, please call and ask to speak to the
            freight department.
          </p>
          <div className="row">
            <div className="col-md">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title">Contact Info</h5>
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item">
                      Direct Line: 631.647.3055
                    </li>
                    <li className="list-group-item">
                      <a
                        href="mailto:freight@fireislandferries.com"
                        className="card-link"
                      >
                        freight@fireislandferries.com
                      </a>
                    </li>
                    <li className="list-group-item">
                      <a
                        href="https://fireislandfreight.azurewebsites.net/"
                        className="card-link"
                      >
                        Freight Customer Portal
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md mt-4 mt-md-0">
              <div className="card">
                <div className="card-body">
                  <h5 className="card-title">Table of Contents</h5>
                  <Nav vertical>
                    <NavItem>
                      <NavLink href="#building_supplies">
                        Shipping Building Supplies
                      </NavLink>
                    </NavItem>
                    <NavItem className="d-none d-md-block">
                      <NavLink href="#hours_of_operation">
                        Hours of Operation
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink href="#grocery_delivery">
                        Grocery Delivery
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink href="#label">Labeling Shipments</NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink href="#secure_your_package">
                        Securing Your Package
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink href="#community_policies">
                        Community Policies
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink href="#pricing_and_payment">
                        Pricing and Payment
                      </NavLink>
                    </NavItem>
                  </Nav>
                </div>
              </div>
            </div>
          </div>

          <hr />
          {/* End Freight Information Blurb */}
          <h1 id="building_supplies">Shipping Building Supplies</h1>
          <ul>
            <li>
              <strong>NO</strong> lumber or building supplies of ANY kind will
              be accepted on Saturdays, Sundays or holidays.
            </li>
            <li>
              <strong>NO</strong> lumber or building supplies will be accepted
              after 9:30am Monday thru Friday.
            </li>
            <li>
              <strong>NO</strong> lumber or building supplies will be accepted
              at the Bay Shore main terminal at any time.
            </li>
          </ul>
          <p>
            Building supplies include: kitchen cabinets, plumbing
            supplies/fixtures, windows, doors, tile, flooring, paneling, bulk
            landscape supplies, fireplaces, stairs, hot tubs, etc.
          </p>
          <p>
            Lumber/building supplies are only accepted for same day delivery at
            the end of Maple Avenue.
          </p>
          <hr />
          {/* End Building Supplies */}
          <h1 id="hours_of_operation">Hours of Operation</h1>
          <p>
            All freight boats are scheduled to leave Bay Shore (end of Maple
            Ave.) at 10:00am. Weather permitting, we run Monday through Friday
            year round. During the height of the season, we also run on
            Saturdays.
            <strong>
              This is generally from mid-April to the end of September, call for
              actual dates.
            </strong>
          </p>
          <p>
            For same day deliveries we will accept shipments from 7:00am to
            9:30am at the foot of Maple Avenue. Please inform shippers that the
            earlier the better. Please give us the courtesy of a phone call for
            any large shipments so we can make the proper space accommodations.
          </p>
          <p>
            We will accept commercial deliveries:
            <ul>
              <li>Monday thru Friday 7:00am to 3:30pm </li>
              <li>
                <strong>
                  Saturdays (when freight boat runs) 7:00am to 9:30am
                </strong>
              </li>
            </ul>
          </p>
          <p>
            Liquor will only be accepted for same day shipment. This means
            deliveries will only be accepted Monday thru Friday between 7:00am
            and 9:30am and the same time on Saturdays mid-April thru the end of
            September.
          </p>
          <p>
            <strong>
              Deliveries attempted during other times will be refused and trucks
              will be turned away.
            </strong>
          </p>
          <p>
            If you are sending items back to Bay Shore, please call for an
            estimated time as to when the freight boat will be in your
            community.
          </p>
          <p>For freight house hours:</p>
          <Link to="/info/freight/hours" className="btn btn-primary-outline">
            Click Here
          </Link>
          <hr />

          {/* End Times of Operation */}

          <h1 id="grocery_delivery">Grocery Delivery</h1>
          <p>
            Presently, Fire Island Ferries only accepts groceries from Shop
            Rite, King Kullen, Sherry's Market, Rustic Roots, Uncle Giuseppe's Marketplace and Pat’s Market. They have accounts set up with
            us, and will cover the freight charge. Therefore, we can leave your
            cartons of groceries on the town dock that you have designated when
            placing your grocery order. It is recommended that you continue to
            order your groceries to be delivered to the freight boat before
            10:00 am Monday – Friday. Any further questions with regard to
            ordering groceries or estimated times that the freight boat will be
            in your town, please call the freight department at 631.647.3055.
          </p>

          <p>
            <strong>
              We do not accept deliveries from Instacart, Shipt, Pea Pod or
              Whole Foods.
            </strong>{" "}
            If attempted the order will be refused at the customers expense.
            None of these vendors protect, label or leave an invoice with us.
            Shop Rite in Bay Shore, King Kullen in Bay Shore, Pat's Market in
            East Islip and Sherry's Market in Babylon are the only stores that
            we accept delivery from. You can try ordering directly from Costco
            or BJ's websites to have those non-perishable items sent via UPS or
            FedEx.
          </p>
          <hr />

          {/* Grocery Delivery */}
          <h1 id="label">Labeling Shipments</h1>
          <p>
            All freight going to or from Fire Island must be labeled with{" "}
            <strong>Name</strong> and <strong>Destination</strong>; please have
            each item labeled; improperly labeled items will be refused. Fire
            Island Ferries employees will not label freight, so if someone else
            or a vendor is making the delivery to us please inform them it is
            their responsibility to label each item.
          </p>
          <p>
            When shipping via UPS, Fed Ex, Airborne or any of the other shipping
            services please label your freight as follows:
          </p>
          <div className="row">
            <div className="col-md-6 mb-4">
              <strong>John Doe – Ocean Beach</strong>
              <br />
              99 Maple Ave.
              <br />
              Bay Shore NY 11706
            </div>

            <div className="col-md-6 mb-4">
              <strong>Jane Smith – Fair Harbor</strong>
              <br />
              99 Maple Ave.
              <br />
              Bay Shore NY 11706
            </div>
          </div>
          <p>
            <strong>
              Please remember that without a name and destination on the address
              label we will not accept any deliveries.
            </strong>
          </p>
          <p>
            In order to ensure our receipt of your order please make sure that
            it is shipped via UPS or FedEx to the Fire Island Ferries address
            (99 Maple Ave., Bay Shore, NY 11706) and not to your P.O. Box. When
            filling out the shipping address use the format laid out above.
          </p>
          <p>
            If you call the freight department, to locate a shipment, we ask
            that you please have the tracking number accessible. This will allow
            us to locate your delivery in a more timely and accurate manner.
          </p>
          <hr />

          {/* End Labeling A Shipment */}
          <h1 id="secure_your_package">Securing Your Package</h1>
          <p>
            For personal freight, please have all boxes, cartons, crates, etc.
            closed, sealed and labeled properly. We will not be responsible for
            any items in unsealed containers and reserve the right to refuse
            such containers. If you are dropping off your own freight at the Bay
            Shore main terminal, you can do so as long as the terminal is open.
            If the garage door is closed, ask a parking attendant if they could
            please open it for you.
          </p>
          <p>
            Please remember we are operating in a marine environment that is
            beyond our control. Your freight is being shipped on boats, on the
            water. Therefore, it is subject to wind, salt spray and fog as well
            as the normal rain, sleet, snow and sun variables. If you are
            worried about it, protect it. We strive to make sure all freight we
            ship is protected from the elements, but you are ultimately
            responsible for the proper safeguarding of your property.
          </p>
          <p>
            Please inform any of your vendors, who ship via truck, of these
            basic policies. All freight that requires a signature will be
            accounted for by the number of pieces received. However, if your
            freight is pre-palletized we will sign for one pallet in AS IS
            condition. The Fire Island Ferries reserves the right to refuse a
            shipment if, upon inspection, there is obvious damage. We will only
            sign a shipping invoice if we are provided with a copy for our
            records. The condition we receive your freight is generally the
            condition you receive your freight. No claims can be made for
            freight once it leaves our care and custody. We are not responsible
            for hidden damages. Those claims must be made to the original
            shipper.
          </p>
          <p>
            <strong>
              Please bring any problems to our attention immediately.
            </strong>
          </p>
          <p>
            Due to limited inside, shore side storage, many items will be
            restricted to outside storage. We are not responsible for any items
            left outside overnight. Aside from the obvious gas containers, gas
            powered equipment, propane tanks and barbeques, other items
            requiring outside storage include (but not restricted to): kayaks,
            canoes, windsurfers, sailboats, jet skis, dinghies, soiled laundry,
            nursery stock, lumber, building supplies (see above), golf carts and
            bicycles.
          </p>
          <hr />
          {/* End Securing your package */}
          <h1 id="community_policies">Community Policies</h1>
          <p>
            These specifications are to be combined with all previously
            mentioned information regarding our freight service.
          </p>
          <h2>Ocean Beach, Fair Harbor, Seaview, and Ocean Bay Park</h2>
          <p>
            Each of these communities have a freight house. However, due to
            their small size and the vast quantities of freight transported,
            these freight houses will only be used as temporary waypoints for
            your smaller items, i.e. UPS, FedEx, Amazon and beverage.
            Arrangements MUST be made for same day pick-up of larger and bulk
            items, including but not limited to; bedding, furniture, appliances,
            bicycles, etc. We ask that you please continue to give the freight
            department notice when one of these shipments is expected. In
            addition, any perishable items, landscaping, building material, or
            the like, will not be brought into the freight house.
          </p>
          <p>
            During the off-season the freight house is only open when the
            freight boat is in your community. If you call Bay Shore
            (631.647.3055) after 10:30 AM we will be able to give you a rough
            estimate as to when the boat will be in your town. Please plan on
            getting to the freight house before that time and waiting for the
            boat. During the peak season we will have posted hours of operation
            that can be referenced.
          </p>
          <p>
            We are not responsible for any freight held for 7 days or more.
            Storage charges will begin to accrue after 14 days (equal to freight
            charge for each 7-day period) and we reserve the right to dispose of
            any items left longer than 30 days, at the customer’s expense. Once
            again, bulk items will need to be picked up on the day of delivery.
            Please arrange your shipments accordingly.
          </p>
          <h2>Village of Saltaire</h2>
          <p>
            The Village of Saltaire has a cartage concessionaire (Mr. Jason
            Waters (631)629-8181) who is responsible for moving all freight off
            the dock, in Saltaire. Fire Island Ferries is relieved of further
            liability once Saltaire freight is left on the dock. Please contact
            Mr. Waters ahead of time to make arrangements to have your freight
            delivered to your residence. Fire Island Ferries freight charges are
            from Bay Shore to the Saltaire dock (or vice versa). Because of this
            unique arrangement, homeowners will be held responsible for any
            freight charges that renters or house guests incur and fail to pay.
            Please inform your guests/renters that they must open up a freight
            credit card account through our website. There is a separate and
            unrelated charge for cartage from the dock – please contact Mr.
            Waters for further information.
          </p>
          <h2>Atlantique, Dunewood and Kismet</h2>
          <p>
            These communities do NOT have freight houses. As a result, all
            freight must have a shipping date. For those of you who are dropping
            off freight yourselves please put a shipping date on each item.
            Without a date of shipment on the tag, we cannot assume that you
            will be available to pick up your freight the following day.
            Therefore, that freight would remain in Bay Shore until we receive a
            phone call from you notifying us of what day you will be present to
            gather and pay for your freight. For those who are having freight
            shipped to them via UPS or common carrier, please email us at
            freight@fireislandferries.com or call (631)647-3055 at least a day
            ahead of time (Mon. – Fri. 7:00am through 3:30pm) to let us know of
            your intended shipping date. When you call, make sure to ask for
            someone in the freight department to facilitate the proper
            communication.
          </p>
          <h2>Bay Shore</h2>
          <p>
            Bay Shore has a freight house for returns off of Fire Island. Due to
            the relatively small size of the freight house and the vast quantity
            of freight returned to the mainland, the freight house can only be
            considered as a temporary waypoint for your items. If you are
            shipping freight back to Bay Shore to be picked up by another
            carrier, we would appreciate it if you would arrange a pick up date
            with that company before shipping the item. With this cooperation on
            your end the return will not sit on our side for weeks. As a
            reminder, we are not responsible for any freight held for 7 days or
            more; storage charges will begin to accrue after 14 days (equal to
            freight charge for each 7 day period); we reserve the right to
            dispose of anything left more than 30 days at customer’s expense.
          </p>
          <hr />
          {/* End Community Policies */}
          <h1 id="pricing_and_payment">Pricing and Payment</h1>
          <p>
            All freight charges are due upon receipt unless you have a
            commercial shipping account (including a $1000.00 deposit) or have
            set up a credit card account with us. We ask that customers, who
            have set up a credit card account with us, have a written list of
            the items they are personally delivering to the freight boat. Once
            these items are unloaded out of your vehicle, you can hand a crew
            member your list. This will lower the amount of time that you may
            have to wait when delivering freight. We accept cash, credit cards
            (AMEX, Visa, Mastercard and Discover) and personal checks from Fire
            Island homeowners. If you plan on using your credit card for a
            one-time payment, there will be a $20 minimum. For now, we can only
            accept your card information at the main terminal (Monday-Friday
            10:00-3:30pm) or the end of Maple Avenue when dropping freight off
            for same day delivery (Monday-Friday 7:00am-10:00am). In the height
            of the season, we can also accept your credit card information on
            Saturdays, during the same times. We cannot accept credit card
            information on the Fire Island side. Fire Island Ferries also asks
            that you be present, during freight business hours, in order to
            record your credit card information with us. For that reason we do
            not accept your information over the phone.
          </p>
          <p>
            Due to the vast variability of items we ship, prices are usually set
            upon visual inspection (size and weight) of the item in question,
            and can vary.
          </p>
          <h2>Customer Freight Portal Information</h2>
          <p>
            Fire Island Freight website to open a credit card account:{" "}
            <a
              href="https://fireislandfreight.azurewebsites.net"
              target="_blank"
              rel="noopener noreferrer"
            >
              Freight Customer Portal
            </a>{" "}
            Fire Island Freight has developed a website for the convenience of
            our customers. Many Fire Islanders have asked us to put a system in
            place that eliminates the need to carry cash to drop off or pick up
            freight. Our website allows new residential customers to create an
            account with us, eliminating the need to pay for a shipment at the
            dock. Your credit card will be billed automatically during the
            season. Our website also allows residential and commercial customers
            to view their shipments at any time of day, and for any shipping
            period from the current day to the current season.
          </p>
          <h2>New Residential Customers</h2>
          <p>
            We ask that you set up a residential account with us, using your
            credit card. The website is listed below. The process to open your
            account is very user friendly. You will be asked for your email
            address (required), home and Fire Island contact information, and
            your credit card information. The website and our servers utilize
            current best-of-breed security standards to safeguard your
            information, and all of your sensitive information is encrypted. If
            you do not want to utilize this website to register, kindly call us
            at 631-647-3055 and we can do this over the phone. You can also come
            to the freight house to do so in person. To create your account, go
            to the website listed at the top or bottom of this letter. Please
            utilize the Print ID function after logging in. With this feature
            you can print out label ID’s for freight that you are dropping off
            yourselves. It will list your name, beach, and account number.
          </p>
          <h2>Existing Residential Customers</h2>
          <p>
            If you have been shipping with us in the past, you probably already
            have your name and address on file in our system. If you have
            already created a credit card account with us, thank you! You do not
            need to do anything at this time. If you have not yet taken
            advantage of our credit card billing, please call the office at
            631.647.3055 or email us at Freight@FirelslandFerries.com. We will
            check that you have an email address in your customer record, and we
            will assign an initial password for your account. You may then log
            in to the website as an existing user, change your password, and
            complete the forms for your account.
          </p>
          <h2>Commercial Customers</h2>
          <p>
            Commercial account holders are free to utilize this website to track
            their shipments, but cannot create a new commercial account. You are
            invoiced customers and billing is done separately.{" "}
            <strong>
              COMMERCIAL CUSTOMERS DO NOT ENTER ANY CREDIT CARD INFO
            </strong>
          </p>
          {/* End Pricing and Payments */}
        </div>
      </div>
    </div>
  </div>
);
